import { ChatChannelType } from 'src/@types/chat';
import { useLocales } from 'src/locales';

export enum ChatCreateTitle {
  TEXT = 'Text',
  GATHERING = 'Gathering',
  DM = 'Direct Message',
}

export type TabProps = {
  tabTitle: string;
  tab: ChatCreateTitle;
  title: string;
  description: string;
  type: ChatChannelType;
  icon: string;
};

export const useChatChannelModalTabs = () => {
  const { translate } = useLocales();

  const tabs: Record<ChatCreateTitle, TabProps> = {
    [ChatCreateTitle.TEXT]: {
      tab: ChatCreateTitle.TEXT,
      tabTitle: translate('communicate.create_modal.text_channel.tab'),
      title: translate('communicate.create_modal.text_channel.title'),
      description: translate(
        'communicate.create_modal.text_channel.description',
      ),
      type: ChatChannelType.TEXT,
      icon: 'tabler:hash',
    },
    [ChatCreateTitle.GATHERING]: {
      tab: ChatCreateTitle.GATHERING,
      tabTitle: translate('communicate.create_modal.gathering_spaces.tab'),
      title: translate('communicate.create_modal.gathering_spaces.title'),
      description: translate(
        'communicate.create_modal.voice_channel.description',
      ),
      type: ChatChannelType.VOICE,
      icon: 'tabler:volume',
    },
    [ChatCreateTitle.DM]: {
      tab: ChatCreateTitle.DM,
      tabTitle: translate('communicate.create_modal.direct_channel.tab'),
      title: translate('communicate.create_modal.direct_channel.title'),
      description: translate(
        'communicate.create_modal.direct_channel.description',
      ),
      type: ChatChannelType.TEXT,
      icon: 'tabler:messages',
    },
  };

  return tabs;
};
